"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = HowToUseModal;
require("core-js/modules/web.dom-collections.iterator.js");
var _react = require("react");
var _ModalState = _interopRequireDefault(require("../../../state-observables/modal/ModalState"));
var _stylesModule = _interopRequireDefault(require("./styles.module.css"));
var _GeneralInfo = _interopRequireDefault(require("./GeneralInfo"));
var _Terminology = _interopRequireDefault(require("./Terminology"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function HowToUseModal() {
  const [activeTab, setActiveTab] = (0, _react.useState)("general-info");
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: _stylesModule.default.howToUseModalContainer,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: _stylesModule.default.tabs,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
        className: "".concat(_stylesModule.default.button, " ").concat(activeTab === "general-info" ? _stylesModule.default.activeTab : ''),
        onClick: () => setActiveTab("general-info"),
        children: "General Info"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
        className: "".concat(_stylesModule.default.button, " ").concat(activeTab === "terminology" ? _stylesModule.default.activeTab : ''),
        onClick: () => setActiveTab("terminology"),
        children: "Terminology"
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: _stylesModule.default.tabContent,
      children: [activeTab === "general-info" && /*#__PURE__*/(0, _jsxRuntime.jsx)(_GeneralInfo.default, {}), activeTab === "terminology" && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Terminology.default, {})]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
      className: " ".concat(_stylesModule.default.closeButton),
      onClick: () => _ModalState.default.closeModal(),
      children: " Close "
    })]
  });
}